/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "button_add": [{
    "type": 0,
    "value": "Agregar"
  }],
  "button_remove_all": [{
    "type": 0,
    "value": "Eliminar todo"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var esMX = Object.assign(TranslationProviderComponent, {
  translations
});

export { esMX as e };
//# sourceMappingURL=es-MX-DdQqS9d9.js.map
